import { Collapse, ListItem, ListItemText } from "@mui/material";
import { ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { LayerGroupCheckbox } from "./LayerGroupCheckbox";
import { LayerGroupRadio } from "./LayerGroupRadio";
import { GenericLayer, Overlayer, LayerGroup as ILayerGroup } from "src/types";

interface Props<T> {
  group: ILayerGroup;
  layers: T[];
  hasNoneOption?: boolean;
  onLayerChange: (layer: T | null, group: ILayerGroup) => void;
}

// TODO: use group type
export function LayerGroup<T extends GenericLayer>(props: Props<T>) {
  const { group, layers, hasNoneOption = false } = props;
  const [isOpen, setIsOpen] = useState(true);
  const { t } = useTranslation();

  return render();

  function render() {
    return (
      <Styles>
        <ListItem button onClick={() => setIsOpen(!isOpen)} className="header">
          <ListItemText primary={t(`layerGroup.${group.name}`)} color="primary" disableTypography />
          {isOpen ? <ExpandLessIcon color="action" /> : <ExpandMoreIcon />}
        </ListItem>

        <Collapse in={isOpen} className="group-content">
          {props.group.type === "checkbox" && (
            <LayerGroupCheckbox<T>
              layers={layers}
              onLayerChange={(layer: T) => {
                props.onLayerChange(layer, props.group);
              }}
            />
          )}

          {props.group.type === "radio" && (
            <LayerGroupRadio<T>
              hasNoneOption={hasNoneOption}
              layers={layers}
              onChange={(layer: T | null) => {
                props.onLayerChange(layer || null, props.group);
              }}
            />
          )}
        </Collapse>
      </Styles>
    );
  }
}

const Styles = styled.div`
  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    border-top: 1px solid #e7e7e7;
    padding: ${({ theme }) => theme.spacing(2, 2)};
    color: ${({ theme }) => theme.palette.text.primary};
  }

  .MuiCollapse-wrapper {
    overflow: auto;
  }
`;
